import React, { FunctionComponent, memo, useContext, useEffect } from 'react'
import WithMusic, { musicContext } from '@hoc/WithMusic'
import AlbumInput from './Album/AlbumInput'
import ArtistAutocompleteInput from './Artist/ArtistAutocompleteInput'
import GenreInput from './Genre/GenreInput'
import { SurveyContext } from '@context/SurveyContext'
import { AlbumEntry } from '@models/Music'
import { usePixelateImage } from '@hooks/usePixelate'
import defaultAlbumImage from './Album/no-album.jpg'
import './MusicInput.scss'
import { useTranslation } from 'react-i18next'

export const MusicInput: FunctionComponent = () => {
  const { t } = useTranslation('Music')
  const { selectedArtist, selectedGenre, selectedAlbum } = useContext(musicContext)
  const { setAnswer } = useContext(SurveyContext)

  const pixelatedAlbum = usePixelateImage(selectedAlbum?.artworkUrl)

  useEffect(() => {
    if (selectedAlbum && selectedArtist)
      setAnswer({
        ...selectedAlbum,
        genre: selectedGenre ?? selectedAlbum.genre,
        pixelatedArtworkUrl: pixelatedAlbum ?? defaultAlbumImage,
        artistId: selectedArtist?.id,
      } as AlbumEntry)
  }, [selectedArtist, selectedGenre, selectedAlbum, pixelatedAlbum])

  return (
    <div className="MusicInput">
      <ArtistAutocompleteInput />
      <div className="genre">
        <label>{t('genreLabel')}</label>
        <GenreInput />
      </div>
      <AlbumInput />
    </div>
  )
}

export default memo(WithMusic(MusicInput))
